import React, {Component} from "react";
import HereService from "../../../../services/Here";
import {TripPreviewIcon} from '../../../../common/icons'

class PositionsDetail extends Component {
  constructor(props) {
    super(props);
    this.mapservice = new HereService();

    this.state = {
      address1: '-',
      address2: '-'
    };
  }

  componentDidMount() {
    if(this.props.trip.positions.length > 0) {
      this.setAddresses();
    }
  }

  setAddresses = async () => {
    const {trip} = this.props;
    this.setState({ address1: '...', address2: '...' });
    const { positions } = this.state;
    const startingPosition = trip.positions[0];
    const endingPosition = trip.positions[trip.positions.length - 1]

    this.setState({
      address1: await this.mapservice.retrieveAddress(startingPosition.loc[1], startingPosition.loc[0], 250),
      address2: await this.mapservice.retrieveAddress(endingPosition.loc[1], endingPosition.loc[0], 250)
    });
  }


  render() {
    return (
      <div className="PositionsDetail">
        <TripPreviewIcon />
        <div className="Positions" >
          <div>{this.state.address1}</div>
          <div>{this.state.address2}</div>
        </div>
      </div>
    )
  }
}
export default PositionsDetail;



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/PositionsDetail.js